export default ['Superficie Appartamento', 'Superficie Giardino', 'Superficie Balcone', 'Superficie Loggia', 'Superficie Terrazzo', 'Superficie Totale'];
